var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"context-menu el-select-dropdown__wrap",style:(_vm.style)},[_vm._t("menu")],2)}
var staticRenderFns = []

export { render, staticRenderFns }